import { Component, Input } from '@angular/core';
import { ServiceType } from '../mf-accounting-service.component';
import { SubscriptionUpdateReason } from '@web-frontend/shared/services/subscription';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'roma-mf-accounting-service-plan',
  templateUrl: './mf-accounting-service-plan.component.html',
  styleUrls: [],
})
export class MfAccountingServicePlanComponent {
  @Input()
  selectedPlan: ServiceType = ServiceType.regularPlans;

  @Input()
  updateReason: SubscriptionUpdateReason | null = null;

  @Input()
  fromUrl: string = window.location.pathname + window.location.search;

  @Input()
  isModal = false;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      this.updateReason = params['updateReason'];
      this.fromUrl = params['fromUrl'] || this.fromUrl;

      // Detect if this is a modal based on query params
      if (params['mode'] !== 'modal') {
        return;
      }
      this.isModal = true;
      // Handle different modal types
      if (params['updateReason'] === SubscriptionUpdateReason.seats) {
        this.selectedPlan = ServiceType.addSeats;
        return;
      }

      const openPlans = params['openPlans'];
      if (
        [ServiceType.onboardingPlan, ServiceType.paymentSuccess].includes(
          openPlans
        )
      ) {
        this.selectedPlan = openPlans;
        return;
      }
    });
  }
}
